import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import styles from "./ReplaceCsvConfirmModal.module.css";

interface ReplaceCsvConfirmModalProps {
  isOpen: boolean;
  fileName: string;
  rowCount: number;
  onKeepCurrent: () => void;
  onReplace: () => void;
}

/** Confirms replacing a parsed CSV, including mappings and validation state. */
export function ReplaceCsvConfirmModal({
  isOpen,
  fileName,
  rowCount,
  onKeepCurrent,
  onReplace,
}: ReplaceCsvConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <Heading slot="title">Replace uploaded file?</Heading>
        </div>

        <p className={styles.message}>
          {fileName} will replace {rowCount} parsed row
          {rowCount === 1 ? "" : "s"}, including mappings, edits, and validation
          results.
        </p>

        <div className={styles.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onKeepCurrent}>
              Keep current file
            </Button>
            <Button variant="tertiary" onPress={onReplace}>
              Replace file
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
